import logo from '../images/FidelitusFMS.png'
import gallery_logo1 from '../images/gallery_logo.png'
import support_us from '../images/support_us.png'

// other business service icon 
import speedyProcess from '../images/other_business_step/SpeedyProcess.png'
import dedicatedExpert from '../images/other_business_step/Dedicatedexpert.png'
import dynamicDatabase from '../images/other_business_step/Dynamicdatabase.png'
import clearCommunication from '../images/other_business_step/ClearCommunication.png'
import resumeDatabase from '../images/other_business_step/80k.png'
import emergingIndividual from '../images/other_business_step/EmergingIndividuals.png'
import fastestGrowing from '../images/other_business_step/FastestGrowing.png'
import serviceOffered from '../images/other_business_step/ServicesOfferred.png'

// service icon
import s1ico from '../images/service_icon/s1ico.png'
import s2ico from '../images/service_icon/s2ico.png'
import s3ico from '../images/service_icon/s3ico.png'
import s4ico from '../images/service_icon/s4ico.png'



export const gallerylogo = gallery_logo1


export const mobile = '+91 9845062227'
export const email = 'info@fidelituscorp.com'
export const address = 'Fidelitus Corp, Brigade Software Park, No. 42, Ground Floor,B Block, 27th Cross,Banashankari 2nd Stage, Bangalore – 560070, Karnataka.'
export const department = 'Fidelitus HR Lab'

export const email_regex = new RegExp('[a-z0-9]+@[a-z]+\.[a-z]{2,3}');


export const servicesArr = [
    {   
        id:1,
        label:'Commercial Interior/ Industrial Design and Architectural Services',
        image:s1ico,
        path:'/services/commercial-interior-design-and-architecture'
    },
    {
        id:2,
        label:'MEP / HVAC and Networking Services',
        image:s2ico,
        path:'/services/mep-hvac-and-networking'
    },
    {
        id:3,
        label:'Project Evaluation and Estiamtion',
        image:s3ico,
        path:'/services/project-evaluation-and-estimation'
    },
    {
        id:4,
        label:'Turnkey Project Execution and General Contracting Services',
        image:s4ico,
        path:'services/turnkey-project-execution-and-general-contracting'
    }
]

export const otherService1Arr = [
    {
        id:1,
        image:resumeDatabase,
        heading:'Talent Acquisition & Management',
        description:'Permanent & Temporary Recruitment solutions for all kinds of industries'
    },
    {
        id:2,
        image:emergingIndividual,
        heading:'Learning & Development',
        description:'We provide a range of Learning & Developing programs at Institutional and Corporate levels'
    },
    {
        id:3,
        image:fastestGrowing,
        heading:'Organization Transformation',
        description:'Let us be your extended HR team to transform your business portfolio for the better'
    },
    {
        id:4,
        image:serviceOffered,
        heading:'Startup Labs',
        description:'Want to launch a successful business? Let us build your core system'
    }
]

export const otherServiceArr = [
    {
        id:1,
        image:speedyProcess,
        heading:'Speedy Process',
        description:'With our vast experience in this industry, we assure timely service'
    },
    {
        id:3,
        image:dedicatedExpert,
        heading:'Dedicated expert',
        description:'An expert manager will be guiding you in every step for your requirements'
    },
    {
        id:3,
        image:dynamicDatabase,
        heading:'Dynamic database',
        description:'Your needs are met with the highest standards with our unmatched database'
    },
    {
        id:4,
        image:clearCommunication,
        heading:'Clear Communication',
        description:'The whole process will go smoothly, as we believe in crystal clear communication'
    }
]

export const appLogo = logo
export const supportUs = support_us
export const base_url = 'https://fidelitustech.com/api/'
export const image_base_url = 'https://fidelitustech.com/'


export const transaction_website_url = "https://fidelitustransactions.com"
export const project_website_url = "https://fidelitusprojects.web.app/"
export const fms_website_url = "https://fidelitusfms.web.app/"
export const hrlabs_website_url = "https://fidelitushrlabs.com/"
export const fidelitus_gallery_website_url = "https://fidelitusgallery.com/"
